import { lazy, Suspense, useEffect, useState } from 'react'
import { subscribeAchievementUnlocks, type AchievementUnlock } from '@/lib/achievements'
import { useWallets } from '@privy-io/react-auth'
import { pickEthereumSigningWallet } from '@/lib/privyWallet'

const AchievementUnlockOverlay = lazy(async () => {
  const mod = await import('@/components/AchievementUnlockOverlay')
  return { default: mod.AchievementUnlockOverlay }
})

export const AchievementUnlockHost = () => {
  const { wallets } = useWallets()
  const signingWallet = pickEthereumSigningWallet(wallets)
  const wallet = signingWallet?.address ?? ''
  const [pending, setPending] = useState<AchievementUnlock | null>(null)

  useEffect(() => {
    return subscribeAchievementUnlocks((unlock) => {
      setPending(unlock)
    })
  }, [])

  if (!pending || !wallet) return null

  return (
    <Suspense fallback={null}>
      <AchievementUnlockOverlay unlock={pending} wallet={wallet} onDismiss={() => setPending(null)} />
    </Suspense>
  )
}
